import React from "react";

const BaseInnerWrapper = ({ children, className }) => {
  return <section className={`${className}  xl:mx-56  lg:!max-w-[1200px] lg:!mx-auto`}>{children}</section>;
};

export default BaseInnerWrapper;
